<template>
  <DialogTemplate v-bind="usedProps" @close="emit('close')">
    <p v-cleaned="htmlText">{{ htmlText }}</p>
    <template #footer>
      <ul>
        <li v-if="labelDismiss">
          <ButtonBase
            stroke="n"
            size="small"
            theme="secondary"
            variant="outlined"
            rounded
            @click="emit('close')"
          >
            {{ labelDismiss }}
          </ButtonBase>
        </li>
        <li>
          <ButtonBase
            stroke="n"
            size="small"
            theme="secondary"
            rounded
            @click="emit('confirm')"
          >
            {{ labelConfirm }}
          </ButtonBase>
        </li>
      </ul>
    </template>
  </DialogTemplate>
</template>
<script lang="ts" setup>
interface Props {
  htmlText: string;
  textOk: string;
  mandatory: boolean;
  confirmButton?: string;
  dismissButton?: string;
}
const props = defineProps({
  htmlText: null,
  textOk: null,
  mandatory: { type: Boolean },
  confirmButton: null,
  dismissButton: null
});
const emit = defineEmits(["close", "confirm"]);
const usedProps = computed(() => {
  return {
    ...props,
    showControls: !props.mandatory,
    closeClickOutside: !props.mandatory,
  };
});
const labelDismiss = computed(() => props.dismissButton || null);
const labelConfirm = computed(() => {
  return props.confirmButton || props.textOk;
});
</script>
<style lang="scss" scoped>
p {
  line-height: var(--text_lh_l);
}
ul {
  display: flex;
  flex-direction: row;
  gap: 1.2rem;
  align-items: center;
  justify-content: center;
}
</style>
